import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAffiliateAuth } from '../../contexts/AffiliateAuthContext';

const AffiliateProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAffiliateAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/affiliate/login" replace />;
  }

  return children;
};

export default AffiliateProtectedRoute;

